import FeaturedCarsSlider from "./FeaturedCarsSlider"
export default FeaturedCarsSlider
